import React, { Fragment, useEffect } from "react"
import { compose } from "redux"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import { makeSelectDimensionsData, makeSelectIsLoading, makeSelectIsLoadingDimensionsData, makeSelectMeasureEngagement } from "./selectors"
import { getDimensionsDataWatcher, getMeasureEngagementWatcher } from "./actions"

import "./index.less"

import SummaryWidgets from "../SummaryWidgets"
import { Spin } from "antd"
import WidgetQualitativeQuestion from "../WidgetQualitativeQuestion"
import WidgetAnalysisSegment from "../WidgetAnalysisSegment"
import WidgetResultByDimensionEngagementAmbassador from "./components/WidgetResultByDimensionEngagementAmbassador"
import { LOCAL_CHECKBOX_EXCLUDE, LOCAL_ISOLATED_METRICS, isAmbassadorActive, isLeaderActive } from "../../../utils/storage"
import WidgetResultByDimensionEngagement from "./components/WidgetResultByDimensionEngagement"
import WidgetResultByDivisionEngagement from "./components/WidgetResultByDivisionEngagement"
import { validate } from "../../../utils/functions"
import WidgetMultipleChoiceQuestions from "../WidgetMultipleChoiceQuestions"
import SummaryQuestions from "../SummaryQuestions"
import WidgetResume from "../WidgetResume"
import { get } from "lodash"
import WidgetResultByDimension from "../ClimateMeasurement/components/WidgetResultByDimension"
import WidgetResultByDimensionAmbassador from "../ClimateMeasurement/components/WidgetResultByDimensionAmbassador"
import { verifyFeatureFlag } from "../../../utils/feature-flags"

export function EngagementMeasurement(props) {
  useEffect(() => {
    initGetData().then(() => {})
  }, [props.idMeasure, props.idDivisionSelected])

  const initGetData = async () => {
    
    const {
      idMeasure,
      getMeasureEngagement,
      getDimensionsData,
      idDivisionSelected,
      idDivisionParent,
      selectedSegment,
      measureGeneral
      
    } = props
    
    getDimensionsData({
      isHome: true,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      id_segment: selectedSegment,
      history,
      isExclude:
        LOCAL_CHECKBOX_EXCLUDE() == "true" &&
        LOCAL_ISOLATED_METRICS() == "true",
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    })
    getMeasureEngagement({
      isHome: true,
      id_measure: idMeasure,
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    })
    
  }

  const renderResultByDimension = () => {
    const {
      typeMeasurement,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureTotal,
      measureGeneral,
      selectedSegment,
      history,
      dimensionsData
    } = props

    if (measureGeneral.segments.length > 0 && selectedSegment === null) {
      if (isAmbassadorActive()) {
        return (
          <WidgetResultByDimensionAmbassador
            typeMeasurement={typeMeasurement}
            idMeasure={idMeasure}
            measureTotal={measureTotal}
            measureGeneral={measureGeneral}
            idDivisionSelected={idDivisionSelected}
            idDivisionParent={idDivisionParent}
            selectedSegment={selectedSegment}
          />
        )
      }
      return (
        <WidgetResultByDimension
          typeMeasurement={typeMeasurement}
          idMeasure={idMeasure}
          measureTotal={measureTotal}
          measureGeneral={measureGeneral}
          idDivisionSelected={idDivisionSelected}
          idDivisionParent={idDivisionParent}
          selectedSegment={selectedSegment}
          dimensionsData={dimensionsData}
        />
      )
    }
    if (!validate.exist(idMeasure)) {
      return null
    }
    if (isAmbassadorActive()) {
      return (
        <WidgetResultByDimensionEngagementAmbassador
          typeMeasurement={typeMeasurement}
          idMeasure={idMeasure}
          measureTotal={measureTotal}
          measureGeneral={measureGeneral}
          idDivisionSelected={idDivisionSelected}
          idDivisionParent={idDivisionParent}
          selectedSegment={selectedSegment}
        />
      )
    }
    return (
      <WidgetResultByDimensionEngagement
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        history={history}
        measureGeneral={measureGeneral}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
        dimensions={dimensionsData}
      />
    )
  }

  const renderResultByDivision = () => {
    const {
      typeMeasurement,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureTotal,
      measureGeneral,
      measureEngagement,
      selectedSegment,
      dimensionsData,
    } = props
    if (!validate.exist(idMeasure)) {
      return null
    }
   /*  if (
      validate.exist(idDivisionSelected) ||
      validate.exist(idDivisionParent)
    ) {
      return null
    } */
    return (
      <WidgetResultByDivisionEngagement
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        history={props.history}
        measureTotal={measureTotal}
        measureEngagement={measureEngagement}
        measureGeneral={measureGeneral}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
        dimensions={dimensionsData}
      />
    )
  }

  const renderSegmentAnalysis = () => {
    const {
      typeMeasurement,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureTotal,
      measureGeneral,
      selectedSegment,
    } = props
    /* if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null)
    ) {
      return null
    } */

    if (measureGeneral.segments.length >1  && !verifyFeatureFlag('seg2-5') &&  (selectedSegment === 0 || selectedSegment === null)){
      return null
    }

    // verifica si la medicion  tiene segmentos pero no ha sido procesada con la nueva version entonces no se muestra el analisis comparativo
    if(measureGeneral.segments.length > 0 && measureGeneral.new_version === 0 &&  (selectedSegment === 0 || selectedSegment === null)){
      return null
    }

    let newSelectedSegment = selectedSegment

    if (measureGeneral.segments.length === 1) {
      newSelectedSegment = measureGeneral.segments[0].id_segment
    }
    return (
      <WidgetAnalysisSegment
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        measureGeneral={measureGeneral}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={newSelectedSegment}
      />
    )
  }

  const renderQualitativeQuestions = () => {
    const {
      typeMeasurement,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureTotal,
      measureGeneral,
      selectedSegment,
    } = props
    if (
      (isAmbassadorActive() &&
        !measureGeneral.ambassador_qualitative_results_visible) ||
      !validate.exist(idMeasure)
    ) {
      return null
    }
    if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null)
    ) {
      return null
    }

    return (
      <WidgetQualitativeQuestion
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        measureGeneral={measureGeneral}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
      />
    )
  }

  const renderMultipleChoiceQuestions = () => {
    const {
      typeMeasurement,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureTotal,
      measureGeneral,
      selectedSegment,
    } = props
    if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null)
    ) {
      return null
    }
    return (
      <WidgetMultipleChoiceQuestions
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        measureGeneral={measureGeneral}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
      />
    )
  }

  const setNameMetricsTotalLabel = () => {
    const { measureGeneral, selectedSegment } = props
    /* let response =
      measureGeneral.id_survey_type === 1
        ? "Clima Laboral"
        : get(measureGeneral, "survey_type_name", "Clima Laboral") */
    let response = "Engagement"
    if (selectedSegment) {
      response = `${response} - ${get(measureGeneral, "segment_name", "")}`
    }
    return response
  }

  const renderEvolutionAndResult = () => {
    const {
      measureTotal,
      idDivisionSelected,
      idMeasure,
      measureGeneral,
      idDivisionParent,
      selectedSegment,
      measureEngagement,
    } = props
    const isLeadership = false
    return (
      <WidgetResume
        measureGeneral={measureGeneral}
        idMeasure={idMeasure}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        className="WidgetResume boxShadow"
        measureData={measureEngagement}
        isLeadership={isLeadership}
        selectedSegment={selectedSegment}
        title={
          <Fragment>
            <b>{setNameMetricsTotalLabel()}</b>
          </Fragment>
        }
        withEmpty
      />
    )
  }

  const renderSummaryQuestions = () => {
    const {
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
    } = props
    if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null)
    ) {
      return null
    }
    return (
      <SummaryQuestions
        idMeasure={idMeasure}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
      />
    )
  }

  if (props.isLoading || props.isLoadingFilter || props.isLoadingDimensionsData) {
    return (
      <div>
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      </div>
    )
  }

  return (
    <div>
      {renderEvolutionAndResult()}
      {renderSummaryQuestions()}
      <SummaryWidgets
        typeMeasurement={props.typeMeasurement}
        idMeasure={props.idMeasure}
        history={props.history}
        measureGeneral={props.measureGeneral}
        measureTotal={props.measureTotal}
        measureEngagement={props.measureEngagement}
        idDivisionSelected={props.idDivisionSelected}
        idDivisionParent={props.idDivisionParent}
        selectedSegment={props.selectedSegment}
      />
      {renderResultByDimension()}
      {renderResultByDivision()}
      {renderSegmentAnalysis()}
      {renderQualitativeQuestions()}
      {renderMultipleChoiceQuestions()}
    </div>
  )
}

EngagementMeasurement.propTypes = {
  typeMeasurement: PropTypes.string,
  idDivisionParent: PropTypes.number,
  idMeasure: PropTypes.number,
  history: PropTypes.object,
  measureGeneral: PropTypes.object,
  isLoading: PropTypes.bool,
  isLoadingFilter: PropTypes.bool,
  measureEngagement: PropTypes.object,
  measureTotal: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  getMeasureEngagement: PropTypes.func,
  selectedSegment: PropTypes.number,
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  isLoadingDimensionsData: makeSelectIsLoadingDimensionsData(),
  measureEngagement: makeSelectMeasureEngagement(),
  dimensionsData: makeSelectDimensionsData(),
})

function mapDispatchToProps(dispatch) {
  return {
    getMeasureEngagement: (params) =>
      dispatch(getMeasureEngagementWatcher(params)),
    getDimensionsData: params => dispatch(getDimensionsDataWatcher(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "engagementMeasurement", reducer })
const withSaga = injectSaga({ key: "engagementMeasurement", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(EngagementMeasurement)
